export default Object.freeze({
  0: {
    id: '0',
    name: 'San Francisco',
    color: 'blue'
  },
  1: {
    id: '1',
    name: 'Chicago',
    color: 'blue'
  },
  2: {
    id: '2',
    name: 'Atlanta',
    color: 'blue'
  },
  3: {
    id: '3',
    name: 'Montreal',
    color: 'blue'
  },
  4: {
    id: '4',
    name: 'Washington',
    color: 'blue'
  },
  5: {
    id: '5',
    name: 'New York',
    color: 'blue'
  },
  6: {
    id: '6',
    name: 'Madrid',
    color: 'blue'
  },
  7: {
    id: '7',
    name: 'London',
    color: 'blue'
  },
  8: {
    id: '8',
    name: 'Paris',
    color: 'blue'
  },
  9: {
    id: '9',
    name: 'Essen',
    color: 'blue'
  },
  10: {
    id: '10',
    name: 'Milan',
    color: 'blue'
  },
  11: {
    id: '11',
    name: 'St. Petersburg',
    color: 'blue'
  },
  12: {
    id: '12',
    name: 'Los Angeles',
    color: 'yellow'
  },
  13: {
    id: '13',
    name: 'Mexico City',
    color: 'yellow'
  },
  14: {
    id: '14',
    name: 'Lima',
    color: 'yellow'
  },
  15: {
    id: '15',
    name: 'Santiago',
    color: 'yellow'
  },
  16: {
    id: '16',
    name: 'Bogota',
    color: 'yellow'
  },
  17: {
    id: '17',
    name: 'Miami',
    color: 'yellow'
  },
  18: {
    id: '18',
    name: 'Buenos Aires',
    color: 'yellow'
  },
  19: {
    id: '19',
    name: 'Sao Paulo',
    color: 'yellow'
  },
  20: {
    id: '20',
    name: 'Lagos',
    color: 'yellow'
  },
  21: {
    id: '21',
    name: 'Kinshasa',
    color: 'yellow'
  },
  22: {
    id: '22',
    name: 'Johannesburg',
    color: 'yellow'
  },
  23: {
    id: '23',
    name: 'Khartoum',
    color: 'yellow'
  },
  24: {
    id: '24',
    name: 'Algiers',
    color: 'black'
  },
  25: {
    id: '25',
    name: 'Cairo',
    color: 'black'
  },
  26: {
    id: '26',
    name: 'Istanbul',
    color: 'black'
  },
  27: {
    id: '27',
    name: 'Baghdad',
    color: 'black'
  },
  28: {
    id: '28',
    name: 'Riyadh',
    color: 'black'
  },
  29: {
    id: '29',
    name: 'Moscow',
    color: 'black'
  },
  30: {
    id: '30',
    name: 'Tehran',
    color: 'black'
  },
  31: {
    id: '31',
    name: 'Karachi',
    color: 'black'
  },
  32: {
    id: '32',
    name: 'Mumbai',
    color: 'black'
  },
  33: {
    id: '33',
    name: 'Delhi',
    color: 'black'
  },
  34: {
    id: '34',
    name: 'Chennai',
    color: 'black'
  },
  35: {
    id: '35',
    name: 'Kolkata',
    color: 'black'
  },
  36: {
    id: '36',
    name: 'Jakarta',
    color: 'red'
  },
  37: {
    id: '37',
    name: 'Bangkok',
    color: 'red'
  },
  38: {
    id: '38',
    name: 'Beijing',
    color: 'red'
  },
  39: {
    id: '39',
    name: 'Shanghai',
    color: 'red'
  },
  40: {
    id: '40',
    name: 'Hong Kong',
    color: 'red'
  },
  41: {
    id: '41',
    name: 'Ho Chi Minh City',
    color: 'red'
  },
  42: {
    id: '42',
    name: 'Seoul',
    color: 'red'
  },
  43: {
    id: '43',
    name: 'Taipei',
    color: 'red'
  },
  44: {
    id: '44',
    name: 'Manila',
    color: 'red'
  },
  45: {
    id: '45',
    name: 'Tokyo',
    color: 'red'
  },
  46: {
    id: '46',
    name: 'Osaka',
    color: 'red'
  },
  47: {
    id: '47',
    name: 'Sydney',
    color: 'red'
  }
});



/** WEBPACK FOOTER **
 ** ./src/constants/cities.js
 **/